


interface ProgressConfig{
    progressGroups:{ [key:string]:string }[],
    [others: string]: any
}


export default function(config:ProgressConfig){

    const initialState = {
        groups: config.progressGroups
    }


    return function(state = initialState, action){

        switch(action.type){
            default: return state
        }

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/progress/progress-reducer.ts